<template>
    <div>

        <b-row>
            <b-col lg=5 v-if="data.alerts.length > 0">

                <div class="tab-sub-block">
                    <div class="tab-block-title">預警注意</div>
                    <div class="tab-block-sub-title">依環境參數統計發生預警的天數</div>
                    <div>
                        <div v-for="(alert, idx) in data.alerts" :key="idx" :class="'alert-block btn-stress btn-stress_' + alert.code" >
                            
                            <div class="alert-text" v-html="getStressBtnText(alert.code)"></div>
                            <div class="alert-count">
                                {{ alert.days }} {{ $t('u.days') }}
                            </div>
                        </div>
                    </div>

                </div>

            </b-col>
            <b-col :lg="( data.alerts.length > 0 ? 6 : 12 )">
                
                <div class="tab-sub-block">
                    <div class="tab-block-title">生長期間環境數據摘要</div>
                    <div class="tab-block-sub-title">依環境參數統計</div>
                    <div v-if="data.statistic.air_temperature">
                        <b-button variant="success" size="sm" class="tab-sub-buttons" @click="collapse.air_temperature = !collapse.air_temperature">
                            <span class="block-text">{{ $t('sensor.air_temperature') }}</span>
                            <i :class="$tools.style.classToggle(collapse.air_temperature)"></i>
                        </b-button>
                        <b-collapse id="collapse-overall-air_temperature" class="tab-sub-buttons-block" v-model="collapse.air_temperature">

                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_low_temp') }} ：</div>
                                {{ data.statistic.air_temperature.avg_daily_low_temp }} {{ $t('sensor.u_avg_daily_low_temp') }}
                            </div>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_high_temp') }} ：</div>
                                {{ data.statistic.air_temperature.avg_daily_high_temp }} {{ $t('sensor.u_avg_daily_high_temp') }}
                            </div>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_temp') }} ：</div>
                                {{ data.statistic.air_temperature.avg_daily_temp }} {{ $t('sensor.u_avg_daily_temp') }}
                            </div>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_diff_temp') }} ：</div>
                                {{ data.statistic.air_temperature.avg_daily_diff_temp }} {{ $t('sensor.u_avg_daily_diff_temp') }}
                            </div>
                        
                        </b-collapse>
                    </div>
                        
                    <div v-if="data.statistic.air_humidity">
                        <b-button variant="success" size="sm" class="tab-sub-buttons" @click="collapse.air_humidity = !collapse.air_humidity">
                            <span class="block-text">{{ $t('sensor.air_humidity') }}</span>
                            <i :class="$tools.style.classToggle(collapse.air_humidity)"></i>
                        </b-button>
                        <b-collapse id="collapse-overall-air_humidity" class="tab-sub-buttons-block" v-model="collapse.air_humidity">
                        
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_low_humidity') }} ：</div>
                                {{ data.statistic.air_humidity.avg_daily_low_humidity }} {{ $t('sensor.u_avg_daily_low_humidity') }}
                            </div>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_high_humidity') }} ：</div>
                                {{ data.statistic.air_humidity.avg_daily_high_humidity }} {{ $t('sensor.u_avg_daily_high_humidity') }}
                            </div>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_humidity') }} ：</div>
                                {{ data.statistic.air_humidity.avg_daily_humidity }} {{ $t('sensor.u_avg_daily_humidity') }}
                            </div>
                            <div>
                                <div class="block-text">{{ $t('sensor.avg_daily_diff_humidity') }} ：</div>
                                {{ data.statistic.air_humidity.avg_daily_diff_humidity }} {{ $t('sensor.u_avg_daily_diff_humidity') }}
                            </div>
                        
                        </b-collapse>
                    </div>
                </div>

            </b-col>
        </b-row>

        
        
        
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: function () { return {} }
        },
        default_collapse: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            collapse: {
                air_temperature: this.default_collapse,
                air_humidity: this.default_collapse,
            },
        }
    },
    watch: {
        default_collapse (val)
        {
            for (let collapse_key in this.collapse)
            {
                this.collapse[ collapse_key ] = val
            }
        },
    },
    methods: {  

        getStressBtnText (alert_code)
        {
            return `<i class="${ this.$tools.style.classStressIcon( alert_code, 'block-text' ) }"></i>${ this.$t('stress.' + alert_code) }`;
        },

    },
}
</script>

<style lang="scss" scoped>

</style>